import { AppEvent } from "@lib/titan2/dist/game/Constants";
import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SlingoEvent } from "./event/SlingoEvent";
/**
 * AppController.ts
 */
export class AppController extends AbstractGameController {
    create() {
        super.create();
        Logger.addObjectRef(this, "AppController");
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.PURCHASE_ENTRY, this.handlePurchaseEntry);
        this.registerGame(CommonGameEvent.START_GAME, this.handleStartGame);
        this.registerGame(CommonGameEvent.SPIN_REQUEST, this.handleSpinRequest);
        this.registerGame(CommonGameEvent.SPIN, this.handleStandardSpin);
        this.registerGame(CommonGameEvent.FREE_SPIN, this.handleFreeSpin);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN, this.handlePurchaseSpin);
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleStandardSpinRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleFreeSpinRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handlePurchaseSpinRecovery);
        this.registerGame(CommonGameEvent.COLLECT_REQUEST, this.handleCollectRequest);
        this.registerGame(SlingoEvent.DAB_ACTIVE, this.handleDabActive);
    }
    handlePurchaseEntry() {
        this.setIdle();
    }
    handleStandardSpin() {
        if (!this.model.isAutoSpin()) {
            this.setIdle();
        }
    }
    handleFreeSpin() {
        if (!this.model.isAutoSpin()) {
            this.setIdle();
        }
    }
    handlePurchaseSpin() {
        this.setIdle();
    }
    handleSpinRequest() {
        this.setBusy();
    }
    handleDabActive() {
        this.setIdle();
    }
    handleStartGame() {
        this.setBusy();
    }
    handleStandardSpinRecovery() {
        this.setIdle();
    }
    handleFreeSpinRecovery() {
        this.setIdle();
    }
    handlePurchaseSpinRecovery() {
        this.setIdle();
    }
    handleCollectRequest() {
        this.setBusy();
    }
    setIdle() {
        this.dispatchCore(AppEvent.IDLE);
    }
    setBusy() {
        this.dispatchCore(AppEvent.BUSY);
    }
}
//# sourceMappingURL=AppController.js.map